import React from "react";
import NumberFormat from "react-number-format";
import BarChart from "./BarChart";
import MonthChoice from "./common/MonthChoice";
import LineChart from "./LineChart";
import { addMonths } from "date-fns";
import format from "date-fns/format";
export default function ProfitSalary(props) {
  let { stats, title, stat, color, chartFormat, year, month } = props;
  const [months, setMonths] = React.useState(6);


  const getMonthsStats = (stats, yr, mo) => {
    return stats.filter(s => s.year === yr && s.month === mo + 1);
  };

  let monthdata = getMonthsStats(stats, year, month)

  //if(months===6 && monthdata.length===0) return <div style={{ height: 310, width:450,display:"flex", justifyContent:"center", alignItems:"center", color:"#ccc"}}>No data</div>

  return (
    <div style={chartFormat}>
      <div className="dflex-sb">
        <h3 style={{ marginLeft: 5, marginBottom: 0 }}>
          {title}:{" "}
          <NumberFormat
            displayType="text"
            value={monthdata[monthdata.length - 1] ? monthdata[monthdata.length - 1][stat] : 0}
            thousandSeparator
          />
        </h3>
        <MonthChoice months={months} setMonths={setMonths} />
      </div>
       <div style={{height:24}}></div>
      <div>
        {months === 1 ? (
          <LineChart
            labels={monthdata.map((s) => s.day)}
            lineData={monthdata.map((s) => s[stat])}
            color={color}
          />
        ) : (
          <BarChart
            labels={getMonthlyData(stats, months, stat,year,month).labels}
            barData={getMonthlyData(stats, months, stat,year,month).data}
            color={color}
          />
        )}
      </div>
    </div>
  );
}

const getMonthlyData = (stats, months, statName,year,month) => {
  let labels = [];
  let data = [];

  let dt = addMonths(new Date(year, month), 1 - months);

/*   stats.sort((a, b) =>
    new Date(a.date) < new Date(b.date)
      ? 1
      : new Date(b.date) < new Date(a.date)
      ? -1
      : 0
  ); */

  for (let i = 0; i < months; i++) {
    const currentDt = dt;
    let _stat = stats.find(
      (s) => s.year === currentDt.getFullYear() && s.month === currentDt.getMonth()+1
    );
    if (_stat) {
      labels.push(format(currentDt, "MMM"));
      data.push(_stat[statName]);
    }
    dt = addMonths(dt, 1);
    /*  console.log(stat); */
  }
  console.log(labels, data);
  return { labels, data };
};


